import { SettingsScreen } from '@/components/settings/SettingsScreen';

export function SettingsPage() {
  return <SettingsScreen />;
}
